import { BookingData } from "@/types/fleet";
import { format, addDays } from "date-fns";
import { de } from "date-fns/locale";

const WHATSAPP_NUMBER = "41797085008";

export const buildWhatsAppLink = (booking: BookingData): string => {
  const { car, date, days, time, customerName, phoneNumber, pickupLocation } = booking;

  // Helper function to format location with clickable link
  const formatLocation = (location: string): string => {
    // Check if location contains coordinates (format: "lat, lng")
    const coordsMatch = location.match(/^(-?\d+\.\d+),\s*(-?\d+\.\d+)$/);
    if (coordsMatch) {
      const [, lat, lng] = coordsMatch;
      return `https://maps.google.com/?q=${lat},${lng}`;
    }
    return location;
  };

  let message = `Hallo! Ich möchte den ${car.title} ab ${format(date, "PPP", { locale: de })}`;
  
  if (days && days > 0) {
    const totalPrice = car.price_per_day_chf * days;
    message += ` für ${days} ${days === 1 ? 'Tag' : 'Tage'} mieten.\n`;
    message += `Abholung ${time}`;
    if (pickupLocation) {
      const locationLink = formatLocation(pickupLocation);
      message += ` an: ${locationLink}\n`;
    } else {
      message += ` in Baar.\n`;
    }
    message += `KM: unbegrenzt.\n`;

    if (car.price_per_day_chf > 0) {
      message += `Preis laut Website: CHF ${totalPrice}.- + CHF 300.- Kaution.\n`;
    } else {
      message += `Preis: auf Anfrage.\n`;
    }
  } else {
    message += ` mieten.\nAbholung ${time}`;
    if (pickupLocation) {
      const locationLink = formatLocation(pickupLocation);
      message += ` an: ${locationLink}\n`;
    } else {
      message += ` in Baar.\n`;
    }
    message += `KM: unbegrenzt.\n`;
    message += `Dauer und Preis: auf Anfrage.\n`;
  }

  message += `Name: ${customerName}.`;
  if (phoneNumber) {
    message += ` Telefon: ${phoneNumber}.`;
  }
  message += ` CH Führerschein vorhanden. Ist es verfügbar?`;

  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
};

export const buildGeneralWhatsAppLink = (message: string): string => {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
};

export const getDefaultWhatsAppMessage = (): string => {
  return "Hallo! Ich brauche einen Mietwagen in Baar. Bitte kontaktieren Sie mich für Details.";
};

export const buildViewedCarMessage = (carTitle: string): string => {
  return `Hallo! Ich habe den ${carTitle} auf Ihrer Website angesehen und hätte gerne mehr Informationen. Ist das Fahrzeug verfügbar?`;
};

export const buildGeneralInquiryWithContext = (viewedCars: string[]): string => {
  if (viewedCars.length === 0) {
    return getDefaultWhatsAppMessage();
  }
  
  let message = "Hallo! Ich habe mir folgende Fahrzeuge auf Ihrer Website angesehen:\n\n";
  viewedCars.forEach((car, index) => {
    message += `${index + 1}. ${car}\n`;
  });
  message += "\nIch hätte gerne mehr Informationen und möchte wissen, welche verfügbar sind.";
  
  return message;
};

export const buildPricingInquiryMessage = (): string => {
  return "Hallo! Ich interessiere mich für Ihre Wochen- und Monatspreise. Können Sie mir bitte mehr Informationen dazu geben?";
};

export const buildFAQFollowUpMessage = (question: string): string => {
  return `Hallo! Ich habe eine Frage zu: ${question}. Können Sie mir bitte weiterhelfen?`;
};
